import { render, staticRenderFns } from "./NewVersionAlert.vue?vue&type=template&id=8aca3c26&scoped=true"
import script from "./NewVersionAlert.vue?vue&type=script&lang=js"
export * from "./NewVersionAlert.vue?vue&type=script&lang=js"
import style0 from "./NewVersionAlert.vue?vue&type=style&index=0&id=8aca3c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca3c26",
  null
  
)

export default component.exports